import { useEffect, useMemo, useState } from 'react'
import { useGetAllAlarmClassesQuery, AlarmClass, CreateAlarmClassCommand, useCreateAlarmClassMutation, useDeleteAlarmClassMutation } from '../../services/alarmClasses'
import { useNavigate } from 'react-router-dom';
import { Page } from '../../components';
import { Search } from 'baseui/icon';
import { Button, KIND, SIZE, SHAPE } from "baseui/button";
import { ButtonGroup } from 'baseui/button-group';
import { Input } from 'baseui/input';
import { IoAdd, IoPencil, IoTrashOutline } from 'react-icons/io5'
import {
    TableBuilder,
    TableBuilderColumn,
} from 'baseui/table-semantic';
import { StyledLink as Link } from 'baseui/link';
import { useStyletron } from 'baseui';
import {
    Checkbox,
    LABEL_PLACEMENT
} from "baseui/checkbox";
import { LoadingView } from '../../components';

const commandItems = (onAdd: any, onEdit: any, onDelete: any, canEdit: boolean, canDelete: boolean) => {
    return [
        {
            key: 'addRow',
            text: 'Add new',
            iconProps: { iconName: 'Add' },
            onClick: onAdd,
        },
        {
            key: 'editRow',
            text: 'Edit',
            iconProps: { iconName: 'Edit' },
            onClick: onEdit,
            disabled: !canEdit
        },
        {
            key: 'deleteRow',
            text: 'Delete',
            iconProps: { iconName: 'Delete' },
            onClick: onDelete,
            disabled: !canDelete
        },

    ]
}
export const AlarmClassesList = () => {
    const navigate = useNavigate();

    // apis
    const { data, error, isLoading, isSuccess, currentData } = useGetAllAlarmClassesQuery()
    const [deleteClass, deleteClassResult] = useDeleteAlarmClassMutation()
    const [createNewClass, createNewClassResult] = useCreateAlarmClassMutation()

    // state
    const [search, setSearch] = useState("");
    const onSearchChanged = (e: any) => setSearch(e.target.value)

    const [, theme] = useStyletron();

    const items = data ? data.filter((a) => a.name.includes(search)).sort((a, b) => a.name.localeCompare(b.name)) : null;
    const isNoData = data ? false : true;

    function onInitClick(): void {

        const cmd: CreateAlarmClassCommand = {
            name: "AlarmNotValid",
            priority: 50,
            iconUrl: 'https://w7.pngwing.com/pngs/821/338/png-transparent-warning-sign-computer-icons-warning-icon-angle-triangle-warning-sign-thumbnail.png',
            onBehavior: {
                ackNecessary: true,
                backgroundColor: theme.colors.notificationWarningBackground,
                foregroundColor: theme.colors.warning500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.warning200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.warning600,
            },
        }
        createNewClass(cmd);

        const cmd0: CreateAlarmClassCommand = {
            name: "OutOfService",
            priority: 50,
            iconUrl: 'https://w7.pngwing.com/pngs/821/338/png-transparent-warning-sign-computer-icons-warning-icon-angle-triangle-warning-sign-thumbnail.png',
            onBehavior: {
                ackNecessary: true,
                backgroundColor: theme.colors.notificationWarningBackground,
                foregroundColor: theme.colors.warning500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.warning200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.warning600,
            },
        }
        createNewClass(cmd0);

        const cmd1: CreateAlarmClassCommand = {
            name: "AlarmDrive",
            priority: 40,
            iconUrl: 'https://th.bing.com/th/id/R.cd9a1da7dc41ef2997cf05c1214e8157?rik=8GK15hL1OgnhCw&pid=ImgRaw&r=0',
            onBehavior: {
                ackNecessary: true,
                backgroundColor: theme.colors.notificationNegativeBackground,
                foregroundColor: theme.colors.negative500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative600,
            },
        }
        createNewClass(cmd1);

        const cmd2: CreateAlarmClassCommand = {
            name: "AlarmValve",
            priority: 40,
            iconUrl: 'https://th.bing.com/th/id/R.cd9a1da7dc41ef2997cf05c1214e8157?rik=8GK15hL1OgnhCw&pid=ImgRaw&r=0',
            onBehavior: {
                ackNecessary: true,
                backgroundColor: theme.colors.notificationNegativeBackground,
                foregroundColor: theme.colors.negative500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative600,
            },
        }
        createNewClass(cmd2);

        const cmd2_1: CreateAlarmClassCommand = {
            name: "AlarmDamper",
            priority: 40,
            iconUrl: 'https://th.bing.com/th/id/R.cd9a1da7dc41ef2997cf05c1214e8157?rik=8GK15hL1OgnhCw&pid=ImgRaw&r=0',
            onBehavior: {
                ackNecessary: true,
                backgroundColor: theme.colors.notificationNegativeBackground,
                foregroundColor: theme.colors.negative500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative600,
            },
        }
        createNewClass(cmd2_1);

        const cmd3: CreateAlarmClassCommand = {
            name: "Alarm",
            priority: 40,
            iconUrl: 'https://th.bing.com/th/id/R.cd9a1da7dc41ef2997cf05c1214e8157?rik=8GK15hL1OgnhCw&pid=ImgRaw&r=0',
            onBehavior: {
                ackNecessary: true,
                backgroundColor: theme.colors.notificationNegativeBackground,
                foregroundColor: theme.colors.negative500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative600,
            },
        }
        createNewClass(cmd3);

        const cmd4: CreateAlarmClassCommand = {
            name: "AlarmNoFeedback",
            priority: 40,
            iconUrl: 'https://th.bing.com/th/id/R.cd9a1da7dc41ef2997cf05c1214e8157?rik=8GK15hL1OgnhCw&pid=ImgRaw&r=0',
            onBehavior: {
                backgroundColor: theme.colors.notificationNegativeBackground,
                foregroundColor: theme.colors.negative500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative600,
            },
        }
        createNewClass(cmd4);

        const cmd5: CreateAlarmClassCommand = {
            name: "CommonAlarm",
            priority: 40,
            iconUrl: 'https://th.bing.com/th/id/R.cd9a1da7dc41ef2997cf05c1214e8157?rik=8GK15hL1OgnhCw&pid=ImgRaw&r=0',
            onBehavior: {
                backgroundColor: theme.colors.notificationNegativeBackground,
                foregroundColor: theme.colors.negative500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative600,
            },
        }
        createNewClass(cmd5);

        const cmd6: CreateAlarmClassCommand = {
            name: "AlarmLow",
            priority: 30,
            iconUrl: 'https://icon-library.com/images/low-icon/low-icon-10.jpg',
            onBehavior: {
                backgroundColor: theme.colors.notificationNegativeBackground,
                foregroundColor: theme.colors.negative500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative600,
            },
        }
        createNewClass(cmd6);

        const cmd7: CreateAlarmClassCommand = {
            name: "AlarmHeigh",
            priority: 30,
            iconUrl: 'https://icon-library.com/images/low-icon/low-icon-10.jpg',
            onBehavior: {
                backgroundColor: theme.colors.notificationNegativeBackground,
                foregroundColor: theme.colors.negative500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative600,
            },
        }
        createNewClass(cmd7);

        const cmd8: CreateAlarmClassCommand = {
            name: "AlarmLimitLow",
            priority: 30,
            iconUrl: 'https://icon-library.com/images/low-icon/low-icon-10.jpg',
            onBehavior: {
                backgroundColor: theme.colors.notificationNegativeBackground,
                foregroundColor: theme.colors.negative500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative600,
            },
        }
        createNewClass(cmd8);

        const cmd9: CreateAlarmClassCommand = {
            name: "AlarmLimitHeigh",
            priority: 30,
            iconUrl: 'https://icon-library.com/images/low-icon/low-icon-10.jpg',
            onBehavior: {
                backgroundColor: theme.colors.notificationNegativeBackground,
                foregroundColor: theme.colors.negative500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative600,
            },
        }
        createNewClass(cmd9);

        const cmd10: CreateAlarmClassCommand = {
            name: "WarningLimitLow",
            priority: 20,
            iconUrl: 'https://icon-library.com/images/low-icon/low-icon-10.jpg',
            onBehavior: {
                backgroundColor: theme.colors.notificationWarningBackground,
                foregroundColor: theme.colors.warning500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.warning200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.warning600,
            },
        }
        createNewClass(cmd10);

        const cmd11: CreateAlarmClassCommand = {
            name: "WarningLimitHeigh",
            priority: 20,
            iconUrl: 'https://icon-library.com/images/low-icon/low-icon-10.jpg',
            onBehavior: {
                backgroundColor: theme.colors.notificationWarningBackground,
                foregroundColor: theme.colors.warning500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.warning200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.warning600,
            },
        }
        createNewClass(cmd11);

        const cmd12: CreateAlarmClassCommand = {
            name: "ManualMode",
            priority: 10,
            iconUrl: 'https://cdn.icon-icons.com/icons2/2066/PNG/512/hand_icon_125264.png',
            onBehavior: {
                backgroundColor: theme.colors.notificationInfoBackground,
                foregroundColor: theme.colors.accent500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.accent200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.accent600,
            },
        }
        createNewClass(cmd12);

        const cmd13: CreateAlarmClassCommand = {
            name: "LocalOperation",
            priority: 10,
            iconUrl: 'https://cdn.icon-icons.com/icons2/2066/PNG/512/hand_icon_125264.png',
            onBehavior: {
                backgroundColor: theme.colors.notificationInfoBackground,
                foregroundColor: theme.colors.accent500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.accent200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.accent600,
            },
        }
        createNewClass(cmd13);

        const cmd14: CreateAlarmClassCommand = {
            name: "Overridden",
            priority: 10,
            iconUrl: 'https://cdn.icon-icons.com/icons2/2066/PNG/512/hand_icon_125264.png',
            onBehavior: {
                backgroundColor: theme.colors.notificationInfoBackground,
                foregroundColor: theme.colors.accent500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.accent200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.accent600,
            },
        }
        createNewClass(cmd14);

        const cmd15: CreateAlarmClassCommand = {
            name: "Acknowledge",
            priority: 0,
            iconUrl: 'https://cdn-icons-png.flaticon.com/512/1642/1642083.png',
            onBehavior: {
                backgroundColor: theme.colors.notificationPositiveBackground,
                foregroundColor: theme.colors.positive500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.positive200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.positive600,
            },
        }
        createNewClass(cmd15);

        const cmd16: CreateAlarmClassCommand = {
            name: "Configuration",
            priority: 10,
            iconUrl: 'https://cdn.icon-icons.com/icons2/2066/PNG/512/hand_icon_125264.png',
            onBehavior: {
                backgroundColor: theme.colors.notificationInfoBackground,
                foregroundColor: theme.colors.accent500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.accent200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.accent600,
            },
        }
        createNewClass(cmd16);

        const cmd17: CreateAlarmClassCommand = {
            name: "Maintenance",
            priority: 10,
            iconUrl: 'https://cdn.icon-icons.com/icons2/2066/PNG/512/hand_icon_125264.png',
            onBehavior: {
                backgroundColor: theme.colors.notificationInfoBackground,
                foregroundColor: theme.colors.accent500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.accent200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.accent600,
            },
        }
        createNewClass(cmd17);

        const cmd18: CreateAlarmClassCommand = {
            name: "Malfunction",
            priority: 50,
            iconUrl: 'https://w7.pngwing.com/pngs/821/338/png-transparent-warning-sign-computer-icons-warning-icon-angle-triangle-warning-sign-thumbnail.png',
            onBehavior: {
                ackNecessary: true,
                backgroundColor: theme.colors.notificationWarningBackground,
                foregroundColor: theme.colors.warning500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.warning200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.warning600,
            },
        }
        createNewClass(cmd18);

        const cmd19: CreateAlarmClassCommand = {
            name: "NoConnection",
            priority: 50,
            iconUrl: 'https://w7.pngwing.com/pngs/821/338/png-transparent-warning-sign-computer-icons-warning-icon-angle-triangle-warning-sign-thumbnail.png',
            onBehavior: {
                ackNecessary: true,
                backgroundColor: theme.colors.notificationWarningBackground,
                foregroundColor: theme.colors.warning500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.warning200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.warning600,
            },
        }
        createNewClass(cmd19);

        const cmd20: CreateAlarmClassCommand = {
            name: "ErrorDamper",
            priority: 40,
            iconUrl: 'https://th.bing.com/th/id/R.cd9a1da7dc41ef2997cf05c1214e8157?rik=8GK15hL1OgnhCw&pid=ImgRaw&r=0',
            onBehavior: {
                ackNecessary: true,
                backgroundColor: theme.colors.notificationNegativeBackground,
                foregroundColor: theme.colors.negative500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.negative600,
            },
        }
        createNewClass(cmd20);

        const cmd21: CreateAlarmClassCommand = {
            name: "Fault",
            priority: 50,
            iconUrl: 'https://w7.pngwing.com/pngs/821/338/png-transparent-warning-sign-computer-icons-warning-icon-angle-triangle-warning-sign-thumbnail.png',
            onBehavior: {
                ackNecessary: true,
                backgroundColor: theme.colors.notificationWarningBackground,
                foregroundColor: theme.colors.warning500,
            },
            offBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.warning200,
            },
            ackedBehavior: {
                backgroundColor: 'transparent',
                foregroundColor: theme.colors.warning600,
            },
        }
        createNewClass(cmd21);
    
    }



    function onAdd(): void {
        navigate('new');
    }

    return (

        <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
            <ButtonGroup kind={KIND.tertiary} size={SIZE.compact}>
                <Button onClick={onAdd} startEnhancer={() => <IoAdd size='1.5em'></IoAdd>}>new</Button>
                {isNoData && <Button onClick={onInitClick} startEnhancer={() => <IoAdd size='1.5em'></IoAdd>}>Init Alarm Groups</Button>}
                {/*<Button onClick={onEdit} startEnhancer={() => <IoPencil></IoPencil>} disabled={!canEdit}>edit</Button>
                <Button onClick={onDelete} startEnhancer={() => <IoTrashOutline></IoTrashOutline>} disabled={!canDelete}>delete</Button>*/}
            </ButtonGroup>
            <Input
                endEnhancer={<Search size="18px" />}
                placeholder="Search..."
                onChange={onSearchChanged}
            />

            <TableBuilder size='compact'
                overrides={{ Root: { style: { height: '100%' } } }}
                data={items || []}
            >
                <TableBuilderColumn header="Icon">
                    {(row: any) => (
                        <img alt="not defined"
                            height={16}
                            src={row.iconUrl}></img>
                    )}
                </TableBuilderColumn>
                <TableBuilderColumn header="Name">
                    {(row: any) => <Link href={`alarmClasses/${row.id}`}>{row.name}</Link>}
                </TableBuilderColumn>
                <TableBuilderColumn header="Priority">
                    {(row: any) => row.priority}
                </TableBuilderColumn>
                <TableBuilderColumn header="On Ack">
                    {(row: any) => <Checkbox
                        checked={row.onBehavior.ackNecessary}
                        disabled
                    >
                    </Checkbox>}
                </TableBuilderColumn>
                <TableBuilderColumn header="On Style">
                    {(row: any) => <StyleCell foreground={row.onBehavior.foregroundColor} background={row.onBehavior.backgroundColor} ></StyleCell>}
                </TableBuilderColumn>
                <TableBuilderColumn header="Ack Style">
                    {(row: any) => <StyleCell foreground={row.ackedBehavior.foregroundColor} background={row.ackedBehavior.backgroundColor} ></StyleCell>}
                </TableBuilderColumn>
                <TableBuilderColumn header="Off Style">
                    {(row: any) => <StyleCell foreground={row.offBehavior.foregroundColor} background={row.offBehavior.backgroundColor} ></StyleCell>}
                </TableBuilderColumn>
            </TableBuilder>
        </LoadingView>

    )
}

function StyleCell({ foreground, background }: any) {
    const [css, theme] = useStyletron();

    return (<span
        data-selection-disabled={true}
        className={css({ color: foreground, background: background, display: 'block' })}>
        Sample
    </span>)
}






